const InviteStatus = Object.freeze({
  PENDING: 'pending',
  SENT: 'sent',
  ACCEPTED: 'accepted',
})

export default InviteStatus